import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { ReactiveFormsModule } from '@angular/forms';
import { LayoutRowModule } from '../../common/directives/layout-row/layout-row.module';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { BannerModule } from '../../common/components/banner/banner.module';

@NgModule({
    declarations: [LoginComponent],
    imports: [
        BannerModule,
        CommonModule,
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule,
        LayoutRowModule,
        MatIconModule
    ],
    exports: [
        LoginComponent
    ]
})
export class LoginModule {}
